module.exports = __webpack_public_path__ + "static/robot-ffa3456dd3febb29f8c9d0b169a2b120.png";